<img class="{{styleClass}}" src="./assets/img/ServBox_Icon.png" (click)="openUrl()">
